// extracted by mini-css-extract-plugin
module.exports = {"path":"SourceInformation_path__1Y_GH","path_textarea":"SourceInformation_path_textarea__1TxUW","id":"SourceInformation_id__3tooK"};